import { render } from "./bank-id-verify.vue?vue&type=template&id=9822012e"
import script from "./bank-id-verify.vue?vue&type=script&lang=js"
export * from "./bank-id-verify.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__